import React from "react";
import { Button } from "../../primary";
import PlusIcon from "../../../static/images/plus-icon_white.svg";
import styles from "./assign.module.scss";

const FormHeader = ({ onAddSection, onAddQuestion, unSectionedQuestions }) => {
  return (
    <div className={`d-flex justify-content-end mb-2`}>
        {unSectionedQuestions?.length === 0 && <Button classes={{ className: `btn ${styles.btn_customs} ${styles.btn_smalls}` }} type="button" onClick={() => onAddQuestion()}>
          <img src={PlusIcon} alt="addQuestion" />
          Add Question
        </Button>}
        <Button classes={{ className: `btn ${styles.btn_customs} ${styles.btn_smalls}` }} type="button" onClick={onAddSection}>
          <img src={PlusIcon} alt="addSection" />
          Add Section
        </Button>
    </div>
  );
};

export default FormHeader;
